import type { CmpConfigPayload, ConsentState, Regime } from "./types";

type Gtag = (...args: unknown[]) => void;

function gtagFn(): Gtag {
  const w = window as Window & { dataLayer?: unknown[]; gtag?: Gtag };
  w.dataLayer = w.dataLayer || [];
  if (typeof w.gtag !== "function") {
    w.gtag = (...args: unknown[]) => { w.dataLayer!.push(args); };
  }
  return w.gtag!;
}

function isOptIn(regime: Regime) {
  return regime === "tcf_eu" || regime === "tcf_uk" || regime === "ch";
}

export function applyConsentDefault(regime: Regime, waitMs = 500, outsideGranted = false) {
  const value = isOptIn(regime) ? "denied" : (outsideGranted ? "granted" : "denied");
  const signals = {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
    functionality_storage: value,
    personalization_storage: value,
    security_storage: "granted",
    wait_for_update: waitMs
  };
  gtagFn()("consent", "default", signals);
  return signals;
}

function purposeGranted(state: ConsentState, ids: string[] | string | undefined): boolean {
  if (ids === "always") return true;
  const list = Array.isArray(ids) ? ids : [];
  if (!list.length) return false;
  return list.every((id) => !!state.purposeConsents[+id]);
}

export function updateGoogleConsentMode(cfg: CmpConfigPayload, state: ConsentState) {
  const mapping = cfg.gcm?.mapping || {};
  const signals = {
    ad_storage: purposeGranted(state, mapping.ad_storage) ? "granted" : "denied",
    ad_user_data: purposeGranted(state, mapping.ad_user_data) ? "granted" : "denied",
    ad_personalization: purposeGranted(state, mapping.ad_personalization) ? "granted" : "denied",
    analytics_storage: purposeGranted(state, mapping.analytics_storage) ? "granted" : "denied",
    functionality_storage: purposeGranted(state, mapping.functionality_storage) ? "granted" : "denied",
    personalization_storage: purposeGranted(state, mapping.personalization_storage) ? "granted" : "denied",
    security_storage: "granted"
  };
  gtagFn()("consent", "update", signals);
  return signals;
}
